var _a;
import "core-js";
import "whatwg-fetch";
import "@webcomponents/webcomponentsjs";
import "systemjs";
import 'kiwi-guide-core/lib/kiwi-core';
import { InfoPointTemplateWrap, InfoPointTemplateBottomWrap } from './infopoint-template';
import { InfoPointTemplateFullscreenWrap, } from './infopoint-templatefullscreen';
import "kiwi-guide-util/lib/components/kiwi-loader";
class Navigator {
    constructor(core, application, navbar, basePath) {
        this.oldPath = '';
        this.basePath = "";
        this.pathname = "/";
        this.paths = ["/"];
        this.core = core;
        this.navbar = navbar;
        this.application = application;
        const regex = /^(\/[^\/]+)(\/.*)$/g;
        let m = regex.exec(basePath);
        if (m && m.length > 2) {
            this.basePath = m[1];
            this.pathname = m[2];
            this.paths[0] = m[2];
            // TODO: FIXME: 
            if (basePath.endsWith("/")) {
                basePath = basePath.slice(0, -1);
            }
            this.navbar.path = this.pathname;
        }
        window.addEventListener('popstate', this.popState.bind(this));
    }
    popState(e) {
        this.paths.pop();
        const vfsPath = e.currentTarget.location.pathname.replace(this.basePath, "") || "/";
        // predani aktualni cesty do sablony
        this.navbar.path = vfsPath;
        // záloha předchozí cesty
        this.oldPath = this.pathname;
        // nastavení nové cesty
        this.pathname = vfsPath;
        let pushPath = this.basePath + vfsPath + location.search;
        history.replaceState({}, '', pushPath);
        this.core.dispatchEvent(new CustomEvent('pathnamechanged', {
            detail: {
                // TODO:
                oldPathname: this.oldPath,
                newPathname: vfsPath
            }
        }));
        console.log('stack after pop', this.paths);
        this.application.analytics().page({
            url: window.location.href,
            path: window.location.pathname
        });
    }
    join(part1, part2) {
        // console.log('join', part1, part2);
        // Pro případy, kdy druhá část začíná /, tak chci root a nechci joinovat
        if (part2.startsWith("/")) {
            return part2;
        }
        if (part1 === "/") {
            part1 = "";
        }
        if (part2 === "/") {
            part2 = "";
        }
        if (part1.endsWith("/")) {
            part1 = part1.slice(0, -1);
        }
        if (part2.startsWith("/")) {
            part2 = part2.slice(1);
        }
        // console.log(`"${part1}" join with "${part2}"`);
        return `${part1}/${part2}`;
    }
    async push(path) {
        console.log('push', path);
        // console.log("push path: ", path)
        // URL bez ID sablony
        let vfsPath = this.join(this.path(), path);
        const fileInfo = await this.application.vfs().stat(vfsPath);
        if (fileInfo.isDir && !vfsPath.endsWith("/")) {
            vfsPath = `${vfsPath}/`;
        }
        if (vfsPath === this.pathname) {
            console.warn('navigation to the same page', path);
            return;
        }
        if (vfsPath === "/") {
            this.paths = [];
        }
        // Mám zajištěný předpoklad, že basePath nebude končit / a pathname bude začínat /
        // TODO: FIXME: pridat location.search
        let pushPath = this.basePath + vfsPath + location.search;
        history.pushState({}, '', pushPath);
        // predani aktualni cesty do sablony
        this.navbar.path = vfsPath;
        // záloha předchozí cesty
        this.oldPath = this.pathname;
        // nastavení nové cesty
        this.pathname = vfsPath;
        this.paths.push(this.pathname);
        console.log('stack after push', this.paths);
        this.core.dispatchEvent(new CustomEvent('pathnamechanged', {
            detail: {
                // TODO:
                oldPathname: this.oldPath,
                newPathname: vfsPath
            }
        }));
        this.application.analytics().page({
            url: window.location.href,
            path: window.location.pathname
        });
    }
    path() {
        return this.pathname;
    }
    async goHome() {
        if (this.paths.length === 1) {
            return;
        }
        this.push(this.paths[0]);
        this.paths = [];
    }
    goBack() {
        // TODO: FIXME:
        console.log('stack before pop', this.paths);
        if (this.paths.length === 1) {
            return;
        }
        this.popState({
            currentTarget: {
                location: {
                    pathname: this.paths[this.paths.length - 2]
                }
            }
        });
    }
}
function getUrlParams(search) {
    if (!search) {
        return {};
    }
    let params = {};
    search.split("&").map((hash) => {
        const [key, val] = hash.split("=");
        params[key] = decodeURIComponent(val.replaceAll("+", "%20"));
    });
    return params;
}
function showError() {
    var _a;
    const error = document.createElement("div");
    error.style.cssText = `
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;`;
    const loader = document.createElement("kiwi-loader");
    loader.style.cssText = `flex: 4;`;
    error.appendChild(loader);
    const textDiv = document.createElement("div");
    textDiv.style.cssText = `
                flex: 2;
                font-size: 3rem;
                display: flex;
                justify-content: center;`;
    textDiv.textContent = "Template ID wasn't found";
    error.appendChild(textDiv);
    (_a = document.getElementById('app')) === null || _a === void 0 ? void 0 : _a.appendChild(error);
}
const configUrl = './config.js';
const core = document.createElement('kiwi-core');
const params = getUrlParams(window.location.search.slice(1));
params.home = params.home || "";
const pathParts = window.location.pathname.match(/[^/]+/g) || [];
let [id] = pathParts;
if (id) {
    const kiwiLoaderWrapper = document.createElement("div");
    kiwiLoaderWrapper.style.cssText = `
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;`;
    kiwiLoaderWrapper.appendChild(document.createElement("kiwi-loader"));
    (_a = document.getElementById('app')) === null || _a === void 0 ? void 0 : _a.appendChild(kiwiLoaderWrapper);
    window.System.import(configUrl).then((config) => {
        (async () => {
            var _a;
            id = decodeURIComponent(id);
            const application = new config.default(id, false);
            const getTemplate = (name) => {
                switch (name) {
                    case "infopoint-templatebottom": return new InfoPointTemplateBottomWrap();
                    case "infopoint-templatefullscreen": return new InfoPointTemplateFullscreenWrap();
                    case "infopoint-templatetop":
                    default: return new InfoPointTemplateWrap();
                }
            };
            // Vytvoření template s navigačním panelem
            let infoPointTemplate = await new InfoPointTemplateWrap().createView();
            const rootFiles = (await application.vfs().readDir(`/`));
            let f;
            if (pathParts.length === 1) {
                // udelat replace/redirect
                const f = rootFiles.find((f) => f.xAttr.target === 'display1.primary');
                if (!f) {
                    throw new Error('no primary content');
                }
                let pathname = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
                pathname = `${pathname}/${f.name}`;
                history.replaceState({}, '', pathname);
            }
            else {
                f = rootFiles.find((f) => f.name === pathParts[1]);
            }
            const root = (await application.vfs().stat(`/`));
            if (root.xAttr && root.xAttr.info && root.xAttr.info.location) {
                try {
                    const templateSettings = JSON.parse(root.xAttr.info.location);
                    const { name } = templateSettings;
                    infoPointTemplate = await getTemplate(name).createView();
                }
                catch (err) {
                    console.warn('wrong template settings', err);
                }
            }
            function makeId(length) {
                let result = '';
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                const charactersLength = characters.length;
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() *
                        charactersLength));
                }
                return result;
            }
            application.analytics().identify(makeId(16), {
                firstName: 'martin',
                lastName: 'pc',
            });
            // Navigacni objekt
            const navigator = new Navigator(core, application, infoPointTemplate, window.location.pathname);
            infoPointTemplate.navigator = navigator;
            infoPointTemplate.application = application;
            infoPointTemplate.homeUrl = params.home;
            infoPointTemplate.addEventListener("viewchanged", (e) => {
                core.viewName = e.detail.viewName;
            });
            core.setApplication(application);
            core.setNavigator(navigator);
            core.setTemplate(infoPointTemplate);
            kiwiLoaderWrapper.remove();
            (_a = document.getElementById('app')) === null || _a === void 0 ? void 0 : _a.appendChild(core);
            var timer = -1;
            // DOM Events
            document.onmousedown;
            document.onmousemove = resetTimer;
            document.onkeydown = resetTimer;
            document.ontouchstart = resetTimer;
            async function onIdle() {
                navigator.push(`/${f.name}`);
            }
            function resetTimer() {
                clearTimeout(timer);
                timer = window.setTimeout(onIdle, 1000 * 60 * 3);
            }
        })();
    });
}
else {
    console.error('no template id');
    showError();
}
/*
* Na GA se dělá mapování, musí být pevné hodnoty
  * lze vytvořit custom dimenzion na které lze mapovat nějaký společný formát
* Na Mixpanelu se žádné mapování nedělá

*/ 
//# sourceMappingURL=main.js.map